/**
 * CP-355: what a Browse cabin filter does and does not cover.
 *
 * /api/cruises?cabin= lists only sailings with a positive price in that class
 * (docs/BROWSE-CABIN-FILTER.md). Oceanview is matched on the stored labels
 * "Oceanview", "Ocean view" and "Outside"; a line that stores its outside cabins
 * under another wording (e.g. "Outside view") is not matched, so Browse says so
 * rather than imply the list is every line's outside cabins.
 *
 * Plain functions only (no imports) so the node test can load this file.
 */
export const OCEANVIEW_COVERAGE_COPY =
  'Oceanview lists cabins priced as Oceanview, Ocean view or Outside. Lines that name their outside cabins another way are not included.';

/** Copy for the coverage strip, or '' when it must not render. */
export function cabinCoverageNote(cabin) {
  return cabin === 'Oceanview' ? OCEANVIEW_COVERAGE_COPY : '';
}

/** " · Balcony fares" tail for the results summary; '' with no cabin. */
export function cabinSummaryTail(cabin) {
  return cabin ? ` · ${cabin} fares` : '';
}
